<template>
  <section
    :class="{
      'section-login': true,
      'light-mode': $route.query.type === 'walmart'
    }"
  >
    <b-img
      class="trebel-logo-redesign only-desk"
      :src="`${publicPath}assets/images/trebel_logo.png`"
      :alt="$t('TREBEL')"
    ></b-img>
    <div class="container">
      <template v-if="!loginSuccess">
        <b-img
          class="backButton"
          :src="`${publicPath}assets/images/backbutton.png`"
          alt="Go Back"
          @click="$router.back()"
        ></b-img>
        <div class="section-login-inner mt-56 mb-40">
          <form @submit.prevent="login" class="d-flex flex-column">
            <h3 class="login-title">
              {{
                $route.query.type === "walmart"
                  ? $t("logIn")
                  : $t("welcomeBack")
              }}
            </h3>
            <h3 class="login-new-subtitle">
              {{ $t("goodToSeeYou") }}
            </h3>

            <div class="form-control-icon-wrap m-0-auto mb-24">
              <div class="input-field-floating">
                <b-form-input
                  :class="{
                    'form-control-walmart': $route.query.type === 'walmart',
                    'error-input':
                      formErrors.findIndex(item => item.field === 'email') !==
                      -1,
                    'valid-input':
                      !formErrors.findIndex(item => item.field === 'email') !==
                        -1 && credentials.email
                  }"
                  v-model="credentials.email"
                  placeholder=""
                  v-validate="'required|email'"
                  type="email"
                  name="email"
                  id="email"
                  data-vv-as="Email"
                  data-vv-validate-on="blur"
                  autocapitalize="off"
                  @keyup.enter="handleEnter($event)"
                ></b-form-input>
                <label>
                  {{ $t("email") }}
                </label>
                <img
                  v-if="credentials.email && credentials.email.length"
                  class="delete-inputed"
                  :src="`${publicPath}assets/images/svg/delete.svg`"
                  alt="delete"
                  @click="credentials.email = ''"
                />
              </div>
              <div v-if="errors.has('email')" class="invalid-field">
                {{ errors.first("email") }}
              </div>
              <div
                v-if="error.message && !errors.has('email')"
                class="invalid-field"
              >
                {{ error.message }}
              </div>
            </div>
            <div class="form-control-icon-wrap m-0-auto">
              <div class="input-field-floating">
                <b-form-input
                  :class="{
                    'form-control-walmart': $route.query.type === 'walmart',
                    'error-input':
                      formErrors.findIndex(
                        item => item.field === 'password'
                      ) !== -1,
                    'valid-input':
                      !formErrors.findIndex(
                        item => item.field === 'password'
                      ) !== -1 && credentials.password
                  }"
                  type="password"
                  v-model="credentials.password"
                  placeholder=""
                  v-validate="'required|min:6'"
                  id="password"
                  name="password"
                  initial="off"
                  data-vv-validate-on="blur"
                  :data-vv-as="$t('password')"
                  @input="checkValidation()"
                  @keyup.enter="handleEnter($event)"
                ></b-form-input>
                <label>{{ $t("password") }}</label>
                <img
                  v-if="credentials.password && credentials.password.length"
                  class="delete-inputed"
                  :src="`${publicPath}assets/images/svg/delete.svg`"
                  alt="delete"
                  @click="credentials.password = ''"
                />
              </div>
              <div v-if="errors.has('password')" class="invalid-field">
                {{ errors.first("password") }}
              </div>
              <div class="mb-24"></div>
            </div>
            <div class="forgot-pass-wrap">
              <b-link
                :to="{
                  name: 'ForgotPassword',
                  query: this.$route.query
                }"
              >
                <p
                  class="forgot-link"
                  :class="{
                    'login-forgot-password': true,
                    'login-forgot-password-dark':
                      $route.query.type === 'walmart'
                  }"
                >
                  {{ $t("forgotYourPassword") }}
                </p>
              </b-link>
            </div>
            <b-button
              type="submit"
              :variant="btnClass"
              class="w-282 align-self-center mt-32"
              :class="{ 'bg-custom': $route.query.da === '1' }"
              block
              :disabled="checkCredentials"
              >{{ $t("continue") }}</b-button
            >
            <div
              v-if="$route.query.type === 'walmart'"
              class="login__for-walmart"
            >
              {{ $t("dontHaveAccount") }}<br /><b
                ><b-link
                  :href="
                    $route.query.redirectTo.replace('/congratulations', '')
                  "
                  >{{ $t("createAccount") }}</b-link
                ></b
              >
            </div>
            <div
              class="login-other-methods"
              :class="{
                'login-subtitle': true,
                'login-subtitle-dark': $route.query.type === 'walmart'
              }"
            >
              <div class="hr"></div>
              {{ $t("orYouCanLogInWithYourEmail") }}
              <div class="hr"></div>
            </div>
            <ui-socials
              :onlyIcon="true"
              @authenticated="handleAuthenticated"
            ></ui-socials>
          </form>
        </div>
      </template>

      <template v-else>
        <div class="mt-40 mb-40 d-flex flex-column align-items-center">
          <img
            :src="`${publicPath}assets/images/check_circle.png`"
            alt="Success"
            class="cicrle-checkmark"
          />

          <h3 class="completed-steps-title">
            {{ $t("successfullLogin") }}
          </h3>
          <div class="create-account-step-text completed-steps-desc p-0 mw-100">
            {{ $t("downloadAppContinue") }}
          </div>

          <img class="qrcode" :src="qr" alt="Trebel QR" />

          <b-button
            variant="yellow"
            block
            class="btn-step-next w-282 "
            @click="redirectTo"
            >{{ $t("continue") }}</b-button
          >
        </div>
      </template>
    </div>
  </section>
</template>

<script>
import { authComputed } from "@/store/helpers.js";
import helpers from "../helpers";
import UiSocials from "@/components/Ui/UiSocials";
export default {
  components: {
    UiSocials
  },
  data() {
    return {
      loginSuccess: false,
      credentials: {
        email: "",
        password: "",
        rememberIsChecked: true
      },
      error: {
        message: ""
      },
      formErrors: [],
      btnClass: this.$route.query.type === "walmart" ? "light" : "yellow",
      validate: false,
      qr: null,
      url:
        "https://app.adjust.com/uyyws65_mmma461?campaign=TrebelAI&adgroup=userreferral&creative=link&fallback=https%3A%2F%2Fhome.trebel.io%2Fid%2Fhome"
    };
  },
  mounted() {
    if (this.$route.query.signIn && this.$route.query.signIn === "1") {
      this.loginSuccess = true;
    }
    this.getQRCode();
  },
  computed: {
    ...authComputed,
    checkCredentials() {
      if (
        this.credentials.email &&
        this.credentials.email.length &&
        this.credentials.password &&
        this.credentials.password.length
      ) {
        return false;
      }
      return true;
    }
  },
  methods: {
    handleEnter(e) {
      if (e.code === "Enter" && e.target.id === "email") {
        document.getElementById("password").focus();
      }
    },
    async getQRCode() {
      const options = {
        width: 180,
        height: 180,
        errorCorrectionLevel: "L",
        type: "image/png",
        rendererOpts: {
          quality: 1
        }
      };

      this.qr = await window.QRCode.toDataURL(this.url, options);
    },
    checkValidation() {
      this.$validator.validateAll().then(result => {
        this.formErrors = this.$validator.errors.items;
        if (this.$route.query.type === "walmart") {
          this.btnClass = !result ? "light" : "yellow";
        } else {
          this.btnClass = this.$route.query.da
            ? "custom-yellow"
            : !result
            ? "yellow"
            : "yellow";
        }
      });
    },
    login() {
      this.validate = true;

      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }
        this.$store
          .dispatch("login", this.credentials)
          .then(async () => {
            this.loginSuccess = true;
            // TMP solution
            // if (this.$route.query.type === "walmart") {
            //   window.location.href = `${
            //     this.$route.query.redirectTo
            //   }&user=${btoa(localStorage.getItem("user"))}`;
            // } else {
            await helpers.fireClevertapEvent({
              event: "login_completed",
              body: {
                source: "login",
                mode: this.$route.query.mode,
                method: "email"
              }
            });
            // if (this.$route.query.type === "walmart") {
            //   helpers.analyticsEvent("walmart_login_or_register_success", {
            //     referrer: "Walmart",
            //     method: "email",
            //     type: "login"
            //   });
            // }
            if (this.$route.query.da && this.$route.query.da === "1") {
              this.$router.push({ path: "/delete-account" }).catch(() => {});
            }
            // }
          })
          .catch(error => {
            this.error.message = error.response.data.error.message;
          });
      });
    },
    redirectTo() {
      window.location.href = this.$route.query.redirectTo
        ? this.$route.query.redirectTo
        : process.env.VUE_APP_REDIRECT;
    },
    handleAuthenticated(from) {
      if (from === "login") this.loginSuccess = true;
    }
  }
};
</script>

<style scoped>
.bg-custom {
  color: #80807b !important;
  background: #444 !important;
  border-radius: 23px !important;
}

/* .btn-custom-yellow {
  background: #fff200 !important;
  color: #000000 !important;
} */
</style>
